import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailerPosLinkSettings) {
    (function(INewItemSettings) {
        (function(ProductState) {
            ProductState["PRODUCT_STATE_UNKNOWN"] = "PRODUCT_STATE_UNKNOWN";
            ProductState["DRAFT"] = "DRAFT";
            ProductState["ACTIVE"] = "ACTIVE";
        })(INewItemSettings.ProductState || (INewItemSettings.ProductState = {}));
        (function(DefaultVariantCreationMethod) {
            DefaultVariantCreationMethod["DEFAULT_VARIANT_CREATION_METHOD_UNKNOWN"] = "DEFAULT_VARIANT_CREATION_METHOD_UNKNOWN";
            /**
       * When variants have the same product, create them as children of the same POS Product
       */ DefaultVariantCreationMethod["GROUP"] = "GROUP";
            /**
       * Create a new POS Product->Variant for every variant
       */ DefaultVariantCreationMethod["SPLIT"] = "SPLIT";
        })(INewItemSettings.DefaultVariantCreationMethod || (INewItemSettings.DefaultVariantCreationMethod = {}));
        (function(NameFormat) {
            /**
       * Use just the item name i.e.: "ITEM_NAME".
       */ NameFormat["ITEM_NAME"] = "ITEM_NAME";
            /**
       * Prefix the item name with the brand's name i.e. "BRAND_NAME – ITEM_NAME".
       */ NameFormat["BRAND_PREFIX"] = "BRAND_PREFIX";
            /**
       * Append the product option name i.e. "ITEM_NAME - OPTION_NAME".
       */ NameFormat["OPTION_SUFFIX"] = "OPTION_SUFFIX";
            /**
       * Prefix with the brand's name and append option name i.e. "BRAND_NAME – ITEM_NAME - OPTION_NAME".
       */ NameFormat["BRAND_AND_OPTION"] = "BRAND_AND_OPTION";
        })(INewItemSettings.NameFormat || (INewItemSettings.NameFormat = {}));
        INewItemSettings.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IRetailerPosLinkSettings.INewItemSettings || (IRetailerPosLinkSettings.INewItemSettings = {}));
    (function(InventoryUpdate) {
        /**
     * Don't adjust inventory counts.
     */ InventoryUpdate["DISABLED"] = "DISABLED";
        /**
     * Update inventory automatically using heuristics e.g. when the order is shipped.
     */ InventoryUpdate["AUTOMATIC"] = "AUTOMATIC";
    })(IRetailerPosLinkSettings.InventoryUpdate || (IRetailerPosLinkSettings.InventoryUpdate = {}));
    (function(DefaultCreateAction) {
        /**
     * Always require review for matching order items
     */ DefaultCreateAction["REQUIRE_REVIEW"] = "REQUIRE_REVIEW";
        /**
     * Automatically create any new order items as a new item in the POS
     */ DefaultCreateAction["CREATE_AUTOMATICALLY"] = "CREATE_AUTOMATICALLY";
        /**
     * @deprecated
     */ DefaultCreateAction["NOT_SELECTED_YET"] = "NOT_SELECTED_YET";
    })(IRetailerPosLinkSettings.DefaultCreateAction || (IRetailerPosLinkSettings.DefaultCreateAction = {}));
    (function(DefaultCurrencyConversionAction) {
        DefaultCurrencyConversionAction["DEFAULT_CURRENCY_CONVERSION_ACTION_UNKNOWN"] = "DEFAULT_CURRENCY_CONVERSION_ACTION_UNKNOWN";
        /**
     * Always convert faire currency to pos currency
     */ DefaultCurrencyConversionAction["AUTO_CONVERT"] = "AUTO_CONVERT";
        /**
     * Do not send price to pos side
     */ DefaultCurrencyConversionAction["DO_NOT_CONVERT"] = "DO_NOT_CONVERT";
    })(IRetailerPosLinkSettings.DefaultCurrencyConversionAction || (IRetailerPosLinkSettings.DefaultCurrencyConversionAction = {}));
    (function(AutoPublishAction) {
        AutoPublishAction["AUTO_PUBLISH_ACTION_UNKNOWN"] = "AUTO_PUBLISH_ACTION_UNKNOWN";
        /**
     * Do not publish on the POS Integration *
     */ AutoPublishAction["DO_NOT_PUBLISH"] = "DO_NOT_PUBLISH";
        /**
     * Automatically publish to POS integration when available *
     */ AutoPublishAction["AUTOMATICALLY_PUBLISH"] = "AUTOMATICALLY_PUBLISH";
    })(IRetailerPosLinkSettings.AutoPublishAction || (IRetailerPosLinkSettings.AutoPublishAction = {}));
    (function(SkuMatching) {
        SkuMatching["SKU_MATCHING_UNKNOWN"] = "SKU_MATCHING_UNKNOWN";
        /**
     * Automatically find SKU-matched items and link them
     */ SkuMatching["AUTOMATIC_SKU_MATCHING"] = "AUTOMATIC_SKU_MATCHING";
        /**
     * User needs to manually trigger the SKU matching
     */ SkuMatching["MANUAL_SKU_MATCHING"] = "MANUAL_SKU_MATCHING";
        /**
     * Default setting before sku matching setting is set to show the first-time banner
     */ SkuMatching["NOT_SET"] = "NOT_SET";
    })(IRetailerPosLinkSettings.SkuMatching || (IRetailerPosLinkSettings.SkuMatching = {}));
    IRetailerPosLinkSettings.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailerPosLinkSettings || (IRetailerPosLinkSettings = {}));
export var IRetailerPosLinkSettings;
